
import { required } from 'vuelidate/lib/validators'

export default {
  visitor: {
    name: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/form/resources/validations.js